export default [
  {
    id: 1000,
    name: "即日配送(一部地域除く)",
    url: "/products?optionalTagId=1000"
  },
  {
    id: 2000,
    name: "３日以内配送(一部地域除く)",
    url: "/products?optionalTagId=2000"
  },
  {
    id: 0,
    name: "おまかせ",
    url: "/products?optionalTagId=0",
    color: true
  },
  {
    id: 1,
    name: "白",
    url: "/products?optionalTagId=1",
    color: true
  },
  {
    id: 2,
    name: "ピンク",
    url: "/products?optionalTagId=2",
    color: true
  },
  {
    id: 3,
    name: "赤リップ",
    url: "/products?optionalTagId=3",
    color: true
  },
  {
    id: 4,
    name: "ブルー",
    url: "/products?optionalTagId=4",
    color: true
  },
  {
    id: 5,
    name: "パープル",
    url: "/products?optionalTagId=5",
    color: true
  },
  {
    id: 6,
    name: "イエロー",
    url: "/products?optionalTagId=6",
    color: true
  },
  {
    id: 7,
    name: "グリーン",
    url: "/products?optionalTagId=7",
    color: true
  },
  {
    id: 8,
    name: "オレンジ",
    url: "/products?optionalTagId=8",
    color: true
  },
  {
    id: 9,
    name: "マリン",
    url: "/products?optionalTagId=9",
    color: true
  },
  {
    id: 10,
    name: "赤系",
    url: "/products?optionalTagId=10",
    color: true
  },
  {
    id: 11,
    name: "黄色・オレンジ系",
    url: "/products?optionalTagId=11",
    color: true
  },
  {
    id: 12,
    name: "白・グリーン系",
    url: "/products?optionalTagId=12",
    color: true
  }
];
